<ng-container *ngIf="itemKeys">
  <div *ngIf="itemMap" class="carousel">
    <div class="carousel__scroller">
      @for (groupNumber of itemKeys(); track groupNumber) {
        <div class="section-container">
          <section
            class="carousel__group"
            id="{{ componentId }}-group-{{ groupNumber }}">
            <ng-container>
              <lib-swipeable (swipeLeft)="navToNext()" (swipeRight)="navToPrev()">
                <app-limited-offer-details [campaign]="itemMap().get(groupNumber)!"
                                           (swipeleft)="navToNext()"
                                           (swiperight)="navToPrev()"></app-limited-offer-details>
                 </lib-swipeable>
              </ng-container>
          </section>
        </div>
      }
    </div>
  </div>
</ng-container>
